export default __webpack_public_path__ + "static/media/project_academia_de_lenguas_2.505dd62a.png";